import JoditEditor from "jodit-react";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import PostHooks from "../../../Hooks/PostHooks";
import UpdateHooks from "../../../Hooks/UpdateHooks";
import { Icon } from "@iconify/react";
import { useQuery } from "../../../Hooks/useApi";

const SuperAdminHero = () => {
  const { data: heroResponse } = useQuery("/hero/getHero");
  const editor = useRef(null);
  const [formData, setFormData] = useState({
    title: "",
    content: "",
  });

  useEffect(() => {
    if (heroResponse?.data?.length) {
      setFormData(heroResponse.data[0]);
    }
  }, [heroResponse]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (formData?._id) {
        await UpdateHooks(
          `https://servercareseebd.careseebd.com/api/v1/hero/updateHero/${formData?._id}`,
          formData
        );
        toast.success("Hero section updated successfully!");
      } else {
        await PostHooks(
          `https://servercareseebd.careseebd.com/api/v1/hero/addHero`,
          formData,
          "Hero section created successfully!"
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="max-w-4xl mx-auto select-none space-y-6">
      {/* Header bar */}
      <div className="flex items-center gap-3 bg-white p-6 rounded-2xl border border-slate-100 shadow-sm">
        <div className="p-3 bg-indigo-50 text-indigo-600 rounded-xl">
          <Icon icon="solar:star-ring-bold" className="w-6 h-6" />
        </div>
        <div>
          <h1 className="text-lg font-black text-slate-800 tracking-tight">Hero Section Settings</h1>
          <p className="text-xs text-slate-400 font-semibold mt-0.5">Edit main title, taglines, and welcome banner copy</p>
        </div>
      </div>

      {/* Main card */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6 lg:p-8">
        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="space-y-1.5">
            <label className="block text-[11px] font-bold text-slate-500 uppercase tracking-wide">Headline Title</label>
            <input
              type="text"
              name="title"
              required
              onChange={handleChange}
              value={formData.title}
              placeholder="e.g. Revolutionizing Medical Workflows"
              className="w-full px-3 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-xs font-semibold text-slate-800"
            />
          </div>

          <div className="space-y-1.5">
            <label className="block text-[11px] font-bold text-slate-500 uppercase tracking-wide">Hero Content</label>
            <div className="rounded-xl overflow-hidden border border-slate-200">
              <JoditEditor
                ref={editor}
                value={formData?.content}
                onChange={(newContent) => {
                  setFormData((prev) => ({
                    ...prev,
                    content: newContent,
                  }));
                }}
              />
            </div>
          </div>

          <div className="pt-2">
            <button
              type="submit"
              className="w-full py-2.5 bg-gradient-to-r from-cyan-500 to-blue-600 hover:opacity-95 text-white font-extrabold text-xs rounded-xl shadow-md shadow-cyan-500/10 hover:-translate-y-0.5 transition-all duration-300 cursor-pointer"
            >
              Update Hero Section
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SuperAdminHero;
